import { keepalive } from '@/API/login/login';
import router from '@/router';
import store from '@/store';

export default class KeepAlive {
  constructor(vm) {
    this.vm = vm;
    this.intervalId = null;
    this.keepaliveInterval =
      process.env.NODE_ENV === 'development' ? 20000 : 10000;
  }
  async checkTokenValid() {
    const currentPath = router.currentRoute.path;
    const isSupervision = currentPath.includes('supervisionHomepage');
    // const tokenKey = isSupervision ? 'supervisionToken' : 'ordinaryToken';
    const tokenKey = 'ordinaryToken'
    const token = localStorage.getItem(tokenKey);
    console.log(token, 'tokentokentokentokentoken');
    if (!token) {
      this.stopKeepalive();
      return false;
    }

    try {
      const response = await keepalive();
      if ([401, 601, 500].includes(response.code)) {
        this.handleInvalidToken(isSupervision);
        return false;
      }
      return true;
    } catch (error) {
      console.error('保活请求失败:', error);
      return false;
    }
  }

  handleInvalidToken(isSupervision) {
    // const userType = isSupervision ? 'supervision' : 'ordinary';
    const userType = 'ordinary';

    // 清除用户数据
    sessionStorage.clear();
    localStorage.clear();
    store.commit(
      `SET_${userType.charAt(0).toUpperCase() + userType.slice(1)}LoggedIn`,
      false,
    );
    // store.commit(
    //   isSupervision ? 'changeSupervisionUser' : 'changeOrdinaryUser',
    //   null,
    // );
    store.commit(
        'changeOrdinaryUser',
        null,
    );
    // 显示提示并跳转
    this.vm.$message.error('登录已过期，请重新登录');
    router.push('/Home/pages');
  }

  startKeepalive() {
    if (this.intervalId) {
      console.warn('保活任务已在运行中');
      return;
    }

    // 立即检查一次
    this.checkTokenValid();

    // 启动定时检查
    this.intervalId = setInterval(() => {
      this.checkTokenValid();
    }, this.keepaliveInterval);

    console.log('保活任务已启动');
  }

  stopKeepalive() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
      console.log('保活任务已停止');
    }
  }
}
